import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">

        {/* ── Brand column ──────────────────────────────────────── */}
        <div className="footer-brand-col">
          <Link to="/" className="footer-logo-link">
            <img src="/Logo-01.png" alt="Ride-Link" className="footer-logo" />
          </Link>
          <p className="footer-tagline">
            Real-time shipment tracking across 100+ carriers worldwide. Fast, secure, and always up-to-date.
          </p>
        </div>

        {/* ── Link columns ──────────────────────────────────────── */}
        <div className="footer-links-grid">
          <div className="footer-col">
            <h5 className="footer-col-title">Product</h5>
            <a href="/#how-it-works">How it Works</a>
            <a href="/#features">Features</a>
            <Link to="/results">Track Shipment</Link>
          </div>

          <div className="footer-col">
            <h5 className="footer-col-title">Account</h5>
            <Link to="/profile">My Profile</Link>
            <Link to="/results">Start Tracking</Link>
            <Link to="/developers">API Keys</Link>
          </div>

          <div className="footer-col">
            <h5 className="footer-col-title">Resources</h5>
            <Link to="/carriers">Carrier Coverage</Link>
            <Link to="/container-prefixes">Container Prefixes</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/developers">Developer API</Link>
          </div>
        </div>

      </div>

      {/* ── Bottom bar ────────────────────────────────────────────── */}
      <div className="site-footer-bottom">
        <p className="footer-copyright">© {year} Ride-Link Systems. All rights reserved.</p>
      </div>
    </footer>
  );
}
